export default __webpack_public_path__ + "static/media/powered-by-healthmark.7b07c957.svg";